export default __webpack_public_path__ + "static/media/triangle-inactive.c8c61bfc.png";